import {
  BarChart as BarChartIcon,
  Lock as LockIcon,
  ExitToApp as ExitToAppIcon,
  AccountCircle as UserIcon,
  People as UsersIcon,
  CorporateFareSharp,
  Security,
  QuestionAnswer,
  VideoLibrary,
  List,
  Add,
  Search,
  Woman,
  GraphicEq,
  MonetizationOn,
  Help,
  Link,
  PersonAdd,
  EventAvailable,
  Forum,
  Notifications as NotificationsIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { RoleTypes } from "../../features/auth/types/roleTypes";
import { NavItemChildProps, NavItemProps } from "./types";

const COMPLAINTS_ANY = "Complaints.*";

export const SideBarItems = (userRoles: string[]) => {
  const { t } = useTranslation();
  const { t: ta } = useTranslation("auth");
  let menuItems: NavItemProps[] = [
    {
      href: "/app/dashboard",
      icon: <BarChartIcon />,
      title: `${t("dashboard")}`,
      role: RoleTypes.ViewDashboard,
    },
    {
      href: "/app/wall",
      icon: <Forum />,
      title: `${t("wall")}`,
      role: RoleTypes.ViewWall,
    },

    {
      href: `/app/employees/`,
      icon: <List />,
      title: `${t("list")}`,
      role: RoleTypes.ViewEmployees,
    },
    {
      href: "/app/employee-detail/00000000",
      icon: <Search />,
      title: "Search",
      role: RoleTypes.ViewEmployees,
    },
    {
      href: `/app/register-candidate/${Math.random().toString(36).slice(2, 12)}`,
      icon: <PersonAdd />,
      title: "Add Basic",
      role: RoleTypes.RegisterCandidate,
    },
    {
      href: `/app/employee/${Math.random().toString(36).slice(2, 12)}`,
      icon: <Add />,
      title: `Add Details`,
      role: RoleTypes.AddEmployees,
    },
    {
      href: "divider",
      icon: <VideoLibrary />,
      title: "videoLibrary",
      role: RoleTypes.ViewEmployees,
    },
    {
      href: "/app/cvs",
      icon: <UsersIcon />,
      title: `${t("candidates")}`,
      role: RoleTypes.ViewCandidates,
    },
    {
      href: "/app/videos",
      icon: <VideoLibrary />,
      title: "Video Cvs",
      role: RoleTypes.ViewEmployees,
    },

    {
      href: "/app/cvp/sulpvc",
      icon: <Woman />,
      title: `${t("cv")}`,
      role: RoleTypes.ViewCv,
    },
    {
      href: "/app/cvm",
      icon: <MonetizationOn />,
      title: `CV Maker`,
      role: RoleTypes.CvMaker,
    },
    // {
    //   href: "",
    //   icon: <Person2 />,
    //   title: `${t("cv")}`,
    //   role: RoleTypes.ViewCandidates,
    //   children: [

    //   ],
    // },
    // {
    //   href: "",
    //   icon: <UsersIcon />,
    //   title: `${t("employees")}`,
    //   role: RoleTypes.ViewEmployees,
    //   children: [],
    // },
    // {
    //   href: "",
    //   icon: <DescriptionSharp />,
    //   title: `${t("visas")}`,
    //   role: RoleTypes.AddVisas,
    //   children: [
    //     {
    //       href: "/app/visas",
    //       icon: <UsersIcon />,
    //       title: `${t("list")}`,
    //       role: RoleTypes.AddVisas,
    //     },
    //     {
    //       href: "/app/visa/0",
    //       icon: <UsersIcon />,
    //       title: `${t("addNew")}`,
    //       role: RoleTypes.AddVisas,
    //     },
    //   ],
    // },
    {
      href: "divider",
      icon: <VideoLibrary />,
      title: "cvDivider1",
      role: COMPLAINTS_ANY,
    },
    {
      href: "",
      icon: <QuestionAnswer />,
      title: `${t("complaints")}`,
      role: COMPLAINTS_ANY,
      children: [
        {
          href: "/app/complaints",
          icon: <UsersIcon />,
          title: `${t("list")}`,
          role: COMPLAINTS_ANY,
        },
        {
          href: "/app/complaints/new",
          icon: <UsersIcon />,
          title: `${t("addNew")}`,
          role: RoleTypes.OpenComplains,
        },
      ],
    },
    {
      href: `/app/follow-ups`,
      icon: <EventAvailable />,
      title: `${t("followUps.title")}`,
      role: [
        RoleTypes.ViewFollowUps,
        RoleTypes.ManageFollowUps,
        RoleTypes.AddMedical,
        RoleTypes.BookEmployeeTicket,
      ],
    },
    {
      href: "divider",
      icon: <VideoLibrary />,
      title: "cvDivider3",
      role: RoleTypes.ViewReports,
    },
    {
      href: "/app/reports",
      icon: <GraphicEq />,
      title: `Reports`,
      role: RoleTypes.ViewReports,
    },
    {
      href: "divider",
      icon: <VideoLibrary />,
      title: "cvDivider3",
      role: "Admin",
    },
    {
      href: "",
      icon: <Security />,
      title: `${ta("admin")}`,
      role: "Admin",
      children: [
        {
          href: "/app/cp",
          icon: <CorporateFareSharp />,
          title: `${ta("companyProfile")}`,
          role: RoleTypes.CompanyManagement,
        },
        {
          href: "/app/users",
          icon: <UsersIcon />,
          title: `${ta("users")}`,
          role: RoleTypes.ManageUsers,
          clickedText: "",
        },
        {
          href: "/app/sessions",
          icon: <Security />,
          title: "Active Sessions",
          role: RoleTypes.ManageUsers,
          clickedText: "",
        },

        {
          href: "/app/c",
          icon: <CorporateFareSharp />,
          title: `${ta("companies")}`,
          role: RoleTypes.ViewCompanies,
          clickedText: "",
        },
      ],
    },
    {
      href: "divider",
      icon: <VideoLibrary />,
      title: "a",
      role: RoleTypes.CompanyProfile,
    },
    {
      href: "/app/profile",
      icon: <UserIcon />,
      title: `${ta("userProfile")}`,
      role: RoleTypes.CompanyProfile,
    },
    {
      href: "/app/notifications",
      icon: <NotificationsIcon />,
      title: `${t("notifications")}`,
      role: [RoleTypes.ViewNotifications, RoleTypes.ViewWall],
    },
    {
      href: "",
      icon: <LockIcon />,
      title: `${ta("changePassword")}`,
      clickedText: "changePassword",
      role: RoleTypes.ChangePassword,
    },
  ];

  const moduleOf = (name: string): string =>
    name.includes(".") ? name.slice(0, name.indexOf(".")) : name;

  // Modules whose roles operate on the employees workspace (list + tabs).
  const WORKSPACE_MODULES = ["Employees", "ProcessControl", "Records"];
  const canAccessEmployeesPage = () =>
    userRoles.some((r) => WORKSPACE_MODULES.includes(moduleOf(r)));

  const checkSingleRolePrivilege = (role: string): boolean => {
    if (role === COMPLAINTS_ANY) {
      return userRoles.some((r) => r.startsWith("Complaints."));
    }

    // Exact match, or write-implies-view within the same module (per-tab
    // `*.View*` roles do not imply the module `.View`).
    if (userRoles.some((userRole) => userRole === role)) return true;
    if (role.endsWith(".View")) {
      const prefix = moduleOf(role) + ".";
      const viewPrefix = prefix + "View";
      return userRoles.some(
        (userRole) =>
          userRole.startsWith(prefix) && !userRole.startsWith(viewPrefix),
      );
    }
    return false;
  };

  const checkUserPrivilege = (item: NavItemProps | NavItemChildProps) => {
    // The employees-list link is reachable by anyone with workspace access.
    if (item.href?.startsWith("/app/employees")) return canAccessEmployeesPage();

    const roles = Array.isArray(item.role) ? item.role : [item.role];
    return roles.some((role) => checkSingleRolePrivilege(role));
  };
  let privilegedMenuItems: NavItemProps[] = [];

  menuItems.forEach((menuItem) => {
    if (menuItem.children) {
      let nestedItem: NavItemChildProps[] = [];
      menuItem.children.forEach((child) => {
        if (checkUserPrivilege(child)) nestedItem.push(child);
      });
      if (nestedItem.length > 0) {
        privilegedMenuItems.push({
          ...menuItem,
          children: nestedItem as NavItemChildProps[],
        });
      }
    } else {
      if (checkUserPrivilege(menuItem)) privilegedMenuItems.push(menuItem);
    }
  });

  privilegedMenuItems = privilegedMenuItems.concat([
    {
      href: "divider",
      icon: <VideoLibrary />,
      title: "divider2",
      role: RoleTypes.ViewEmployees,
    },
    // {
    //   href: "/app/tutors",
    //   icon: <VideoLibrary />,
    //   title: `${t("videos")}`,
    //   role: RoleTypes.ViewEmployees,
    // },
    {
      href: "/app/support",
      icon: <Link />,
      title: `${t("links")}`,
      role: RoleTypes.ViewEmployees,
    },

    {
      href: "",
      icon: <ExitToAppIcon />,
      title: `${ta("signOut")}`,
      clickedText: "logout",
      role: RoleTypes.ViewEmployees,
    },
  ]);
  return privilegedMenuItems;

  // {
  //     href: "/app/settings",
  //     icon: <SettingsIcon />,
  //     title: "Settings",
  //   },
  // {
  //     href: "/app/links",
  //     icon: <Link />,
  //     title: `${t("links")}`,
  //     role: RoleTypes.ViewEmployees,
  //   },
  // {
  //     href: "/app/support",
  //     icon: <HelpCenter />,
  //     title: `${t("support")}`,
  //     role: RoleTypes.ViewEmployees,
  //   },
};
